import { render, staticRenderFns } from "./orders-gallery-files-list.vue?vue&type=template&id=7ad223f3&scoped=true"
import script from "./orders-gallery-files-list.vue?vue&type=script&lang=js"
export * from "./orders-gallery-files-list.vue?vue&type=script&lang=js"
import style0 from "./orders-gallery-files-list.vue?vue&type=style&index=0&id=7ad223f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad223f3",
  null
  
)

export default component.exports